export const generateAMTableCellDataTestId = ({
  itemKey,
}: {
  itemKey: string;
}) => {
  const [year, quarter, dataType] = itemKey.split("|");
  return `${year}${quarter ? `-q${quarter}` : ""}-${dataType}`.toLowerCase();
};
